import React from 'react';
import { cn, getStatusColor, getStatusLabel } from '../lib/utils';
import { Clock, CheckCircle, XCircle, Truck } from 'lucide-react';

const statusIcons = {
    pendiente: Clock,
    autorizado: CheckCircle,
    rechazado: XCircle,
    despachado: Truck,
};

export const StatusBadge = ({ estado, size = 'default', showIcon = true }) => {
    const Icon = statusIcons[estado] || Clock;
    
    return (
        <span
            className={cn(
                'status-badge border',
                getStatusColor(estado),
                size === 'sm' && 'text-[10px] px-1.5 py-0.5',
                size === 'lg' && 'text-sm px-3 py-1'
            )}
            data-testid={`status-badge-${estado}`}
        >
            {showIcon && <Icon className={cn('mr-1.5', size === 'sm' ? 'h-3 w-3' : 'h-4 w-4')} />}
            {getStatusLabel(estado)}
        </span>
    );
};

export default StatusBadge;
